module.exports = __webpack_public_path__ + "img/google-sheets.0efb9bb5.png";